var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fam-picker"},[_c('div',{staticClass:"selection"},[_c('div',{staticClass:"selector"},[_c('adult-avatar-self',{on:{"verify":_vm.onFaceVerify}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }